module.exports = __webpack_public_path__ + "static/media/mode-2020.8e511e5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-2020.svg
// module id = 1048
// module chunks = 2